'use strict';

angular.module('formApp').factory('formHelper', [
  function () {
    return {
      resolveFieldGroup: function (availableFieldGroups, fieldGroupId) {
        var result = {
          title: 'Unbekannte Feldgruppe'
        };

        availableFieldGroups.some(function (e) {
          if (e.id === fieldGroupId) {
            result = e;
            return true;
          }
          return false;
        });

        return result;
      },
      resolveField: function (availableFieldGroups, fieldId) {
        var rows = _.flatten(
          availableFieldGroups.map(function (group) {
            return group.rows || [];
          })
        );

        var fields = _.flatten(
          rows.map(function (row) {
            return row.fields || [];
          })
        );

        var field = _.find(fields, function (field) {
          return field.id === fieldId;
        });

        field = field || {
          title: 'Unbekanntes Feld'
        };

        return field;
      },
      resolveFieldInstance: function (fieldGroup, instance, possibleInstanceValues) {
        if (!fieldGroup.multiple) {
          return '-';
        }

        return possibleInstanceValues[instance + 1].label;
      }
    };
  }
]);
